import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import ContractMoveOut from "@/model/contractMoveOut";

@Module({ namespaced: true })
export default class MoveOutModule extends VuexModule {
  public moveOut: ContractMoveOut = null;
  
  @Mutation
  updateMoveOut(moveOut: ContractMoveOut): void {
    this.moveOut = moveOut;
  }
  

  @Action({ rawError: true })
  setMoveOut(moveOut: ContractMoveOut) {
    this.context.commit("updateMoveOut", moveOut);
  }
  
  get getMoveOut(): ContractMoveOut {
    return this.moveOut;
  }
}